import { MembershipService } from '../membership.service';
import { BackendModule } from '../../../../../modules/backend.module';
import { AlertController, NavController } from 'ionic-angular';
import { Component } from '@angular/core';
import { SessionService } from '../../../../../services/session';
import { LocationsService } from '../../../../../services/locations';
import{ FormGroup, FormControl, Validators} from '@angular/forms';
import { TabsService } from '../../../tabs.service';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-update-membership',
  templateUrl: 'update-membership.html'
})
export class UpdateMembershipPage {
  constructor(
    public alertCtrl: AlertController,
    public sessionService: SessionService,
    public navCtrl: NavController,
    public backendModule: BackendModule,
    public membershipService: MembershipService,
    public locationsService: LocationsService,
    public tabsService: TabsService,
    public iab: InAppBrowser
  ) {}

  membershipForm: FormGroup;
  phone: any;
  now = new Date();
  currentYear = this.now.getFullYear();

  socket : any;
  browser:any;

  ngOnInit() {
    this.getStatesAndCities();
    if (this.sessionService.user.subscription) {
      this.initializeForm(
        this.sessionService.user.subscription.owner_name,
        this.sessionService.user.subscription.address,
        this.sessionService.user.subscription.cp,
        this.sessionService.user.subscription.phone,
        this.sessionService.user.subscription.state,
        this.sessionService.user.subscription.city,

      );
    } else {
      this.initializeForm(null, null, null, null, null, null);
    }
  }

  ngOnDestroy() {
    this.locationsService.removeStatesAndCities();
  }

  getStatesAndCities() {
    this.backendModule.getAPI('locations').subscribe(
      (result: any) => {
        this.locationsService.states = result.states;
        this.locationsService.cities = result.cities;
        this.membershipService.changeCities(this.sessionService.user.subscription.state);
      },
      err => {
        this.sessionService.reportError(
          'updateMembershipPage',
          'getStatesAndCities()',
          err
        );
      }
    );
  }

  initializeForm(name, address, zip, phone, state, city) {
    switch (this.locationsService.country){
      case 'MX':
        this.membershipForm = new FormGroup({
          acceptTerms: new FormControl(false, [Validators.requiredTrue]),
          number: new FormControl(null, [
            Validators.required,
            this.validCardNumber.bind(this)
          ]),
          name: new FormControl(name, Validators.required),
          exp: new FormControl(null, [Validators.required]),
          cvc: new FormControl(null, [
            Validators.required,
            this.validCVC.bind(this)
          ]),
          address: new FormGroup({
            street1: new FormControl(address, [Validators.required]),
            street2: new FormControl(null),
            city: new FormControl(city, [Validators.required]),
            state: new FormControl(state, [Validators.required]),
            zip: new FormControl(zip, [Validators.required]),
            phone: new FormControl(phone, [Validators.required])
          })
        });
          break
      default:
      this.membershipForm = new FormGroup({
        acceptTerms: new FormControl(false, [Validators.requiredTrue]),
      });
    }
  }

  validCardNumber(
    control: FormControl
  ): { [cardNumberIsValid: string]: boolean } {
    /*
    if (this.conektaService.validateNumber(control.value)) {
      return null;
    }
    */
    return { cardNumberIsInvalid: true };
  }

  validCVC(control: FormControl): { [CVCIsValid: string]: boolean } {
    /*
    if (this.conektaService.validateCVC(control.value)) {
      return null;
    }
    */
    return { CVCIsInvalid: true };
  }

  updateMembership() {
    this.socket = this.backendModule.openSocket()
    var urlToLoad: string = `${this.membershipService.paymentsUrl}?processor=${this.locationsService.translate('paymentProcessor')}&user_id=${this.sessionService.user.id}&amount=0&time=${new Date().getTime()}&country=${this.locationsService.versionService.country}`;
    this.openBrowser(urlToLoad)
    this.socket.on('subscriptions', data => {
      console.log(data);
      data=JSON.parse(data);
      console.log(data.user_id, this.sessionService.user.id);
      // will make sure the user gets his own info and if so it will close the iframe and close the socket
      if (data.user_id === this.sessionService.user.id) {
        this.browser.close();
        this.socket.close();
        this.navCtrl.popToRoot();
        this.navCtrl.parent.select(this.tabsService.HOME);
      }
    });
  }

  openBrowser(url) {
    this.iab.create(url, '_blank');
  }

  ionViewWillLeave(){
    // will close the socket when user leaves page
    if(this.socket){
      this.socket.close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/profile/membership/update-membership/update-membership.ts